import { BASE_ERROR404_SHOW, BASE_ERROR404_HIDE } from 'rebook/apps/base/constants';


const initialState = {
  isActive: false,
};

export default function error404(state = initialState, action) {
  switch (action.type) {
    case BASE_ERROR404_SHOW:
      return {
        isActive: true,
      };
    case BASE_ERROR404_HIDE:
      return {
        isActive: false,
      };
    default:
      return state;
  }
}
